export const compra = [
  "Leads",
  "En proceso de venta",
  "Cliente de una vez",
  "Cliente frecuente",
  "Cliente del que buscamos re compra",
  "Cliente que no concretó la compra",
];

export const tamaños = ["Cuentas pequeñas", "Cuentas grandes"];

export const formasPago = [
  {
    value: "contado",
    label: "Contado",
  },
  {
    value: "credito",
    label: "Crédito",
  },
  {
    value: "arrendamiento",
    label: "Arrendamiento",
  },
];

export const vehiculos = [
  "T80 Mamut",
  "TIGUER 1102D",
  "TIGUER 1303D",
  "TIGUER 1605D",
  "TIGUER 1607D",
  "JK6 2412D",
  "JK6 2417 CNG",
  "JK6 3020D",
  "JH6 430 CNG",
  "JH6 430 LNG",
  "JH6 550D",
  "JH6 500D",
];

export const combustibles = ["Diésel", "GNV", "GNL", "Gasolina"];

export const tipos = ["Ligero", "Mediano", "Pesado", "Tractocamión"];

export const funnelChannels = [
  {
    value: "redesSociales",
    label: "Redes sociales (Facebook, Instagram, etc.)",
  },
  {
    value: "google",
    label: "Google",
  },
  {
    value: "tradicional",
    label: "Medios tradicionales (TV, radio, etc.)",
  },
  {
    value: "recomendacion",
    label: "Recomendación",
  },
  {
    value: "agencia",
    label: "Vi la agencia y me acerqué",
  },
  {
    value: "prospecto",
    label: "Prospecte/Puerta",
  },
  {
    value: "coldCall",
    label: "Llamada fría",
  },
  {
    value: "otro",
    label: "Otro",
  },
];

export const titles = [
  {
    value: "lic",
    label: "Licenciado",
  },
  {
    value: "ing",
    label: "Ingeniero",
  },
  {
    value: "mtro",
    label: "Maestro",
  },
  {
    value: "dr",
    label: "Doctor",
  },
  {
    value: "sr",
    label: "Señor",
  },
  {
    value: "sra",
    label: "Señora",
  },
];

export const filtrosTiempo = [
  {
    value: "week",
    label: "Última semana",
  },
  {
    value: "month",
    label: "Último mes",
  },
  {
    value: "trimester",
    label: "Últimos tres meses",
  },
  {
    value: "year",
    label: "Último año",
  },
  {
    value: "all",
    label: "Desde el inicio",
  },
];

export const oportunidadesStatus = [
  {
    value: "",
    label: "Sin contactar",
    color: "#FFB547",
  },
  {
    value: "pending",
    label: "Pendiente",
    color: "#fbb03b",
  },
  {
    value: "scheduled",
    label: "Cita programada",
    color: "#7BC67E",
  },
  {
    value: "quote",
    label: "Cotización enviada",
    color: "#64B6F7",
  },
  {
    value: "files",
    label: "Documentos enviados",
    color: "#455a64",
  },
  {
    value: "signed",
    label: "Pedido firmado",
    color: "#13c7b9",
  },
  {
    value: "deposit",
    label: "Pago de enganche",
    color: "#fbb03b",
  },
  {
    value: "paid",
    label: "Unidad pagada por entregar",
    color: "#bb6bd9",
  },
  {
    value: "delivered",
    label: "Unidad entregada",
    color: "#2b9eb3",
  },
  {
    value: "cancelled",
    label: "Cancelada",
    color: "#ea5455",
  },
];

export const motivosCancelacion = [
  {
    value: "stock",
    label: "Sin Stock",
    icon: "Inventory",
  },
  {
    value: "credito",
    label: "Crédito",
  },
  {
    value: "abandono",
    label: "Abandono",
  },
  {
    value: "tiempo",
    label: "Tiempo respuesta",
  },
  {
    value: "otro",
    label: "Otro",
  },
];

export const platform = [
  {
    value: "redilas",
    label: "Redilas",
  },
  {
    value: "cajaSeca",
    label: "Caja seca",
  },
  {
    value: "remolque",
    label: "Remolque",
  },
  {
    value: "pipa",
    label: "Pipa",
  },
];

export const capacity = [
  {
    value: "1 a 2 Tn",
    label: "1 a 2 Tn",
  },
  {
    value: "3 a 5 Tn",
    label: "3 a 5 Tn",
  },
  {
    value: "6 a 8 Tn",
    label: "6 a 8 Tn",
  },
  {
    value: "9 a 12 Tn",
    label: "9 a 12 Tn",
  },
  {
    value: "13 a 17 Tn",
    label: "13 a 17 Tn",
  },
];

// Funcion que retorna un array de objetos que son para mostrarse en un select
export const getCategoriasFiltros = () => {
  let array = [];
  //Agregar compra, tamaños, vehiculos, combustibles, tipos
  compra.forEach((item) => {
    array.push({
      value: item,
      label: item,
    });
  });
  tamaños.forEach((item) => {
    array.push({
      value: item,
      label: item,
    });
  });
  vehiculos.forEach((item) => {
    array.push({
      value: item,
      label: item,
    });
  });
  combustibles.forEach((item) => {
    array.push({
      value: item,
      label: item,
    });
  });
  tipos.forEach((item) => {
    array.push({
      value: item,
      label: item,
    });
  });
  return array;
};
